import { render, staticRenderFns } from "./SuitesPanel.vue?vue&type=template&id=fbe87b5c&scoped=true"
import script from "./SuitesPanel.vue?vue&type=script&lang=ts"
export * from "./SuitesPanel.vue?vue&type=script&lang=ts"
import style0 from "./SuitesPanel.vue?vue&type=style&index=0&id=fbe87b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe87b5c",
  null
  
)

export default component.exports